import {WB_ControlPointTypeProcessInputRow, WB_ControlPointTypeProcessRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import * as _ from "lodash"
import {esWB_ControlPoint_Type_Process, esWB_ControlPoint_Type_Process_Input} from "../PA.Core/PAdbSchema";

export class ControlPointService
{
    static async getProcesses(dbContext: PAdbContext, wbControlPointMId: number): Promise<WB_ControlPointTypeProcessRow[]> {

        if(_.isEmpty(dbContext))
            return []

        let recs
            = <WB_ControlPointTypeProcessRow[]> await dbContext.findAll(esWB_ControlPoint_Type_Process,
            {where: {WB_CONTROL_POINTM_ID: wbControlPointMId, DELETED_IND: {notIn: ['1']}}})

        return recs
    }

    static async getProcessInputs(dbContext: PAdbContext, wbControlPointMPId: number): Promise<WB_ControlPointTypeProcessInputRow[]> {
        if(_.isEmpty(dbContext))
            return []

        let recs
            = <WB_ControlPointTypeProcessInputRow[]> await dbContext.findAll(esWB_ControlPoint_Type_Process_Input,
            {where: {WB_CONTROL_POINTMPR_ID: wbControlPointMPId, DELETED_IND: {notIn: ['1']}}})

        return recs
    }



}